import { render, staticRenderFns } from "./AccountMigrationModal.vue?vue&type=template&id=1122e163&scoped=true&"
import script from "./AccountMigrationModal.vue?vue&type=script&lang=js&"
export * from "./AccountMigrationModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountMigrationModal.vue?vue&type=style&index=0&id=1122e163&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122e163",
  null
  
)

export default component.exports